import type { TFunction } from 'i18next'

export const getAssigneeTypeLabel = (
  type: 'account' | 'group',
  t: TFunction
): string =>
  type === 'group'
    ? t('rolesAndPermissions.type.group')
    : t('rolesAndPermissions.type.account')
